module.exports = __webpack_public_path__ + "static/media/diabetes-diet-healthy-life-svgrepo-com.e0939d94.svg";